import dayjs from 'dayjs'

export const EXPIRY_LABELS = {
  expired: 'Expired',
  expiring: 'Expiring soon',
}

/** The file's Expiry Date field as a dayjs date, or null when it has none. */
export function expiryDateOf(file) {
  const field = ((file && file.file_information_types) || []).find(
    (item) => item.label && item.label.toLowerCase().includes('expiry'),
  )
  if (!field || !field.value) return null
  const date = dayjs(field.value)
  return date.isValid() ? date : null
}

/** 'expired' | 'expiring' | null, from the status the API keeps in step with the Expiry Date. */
export function expiryState(file) {
  const status = ((file && file.status) || '').toLowerCase()
  if (status === 'expired') return 'expired'
  if (status === 'expiring soon') return 'expiring'
  return null
}
